// extracted by mini-css-extract-plugin
module.exports = {"fancyList":"fancy-list_fancyList__7_6WP"};